import { Component, Input, OnInit } from '@angular/core';
import {
  CardImageAspectRatio,
} from '@vg-constellation/angular-19/card';
import { AemUtil } from '@app/utils/aem.util';
import { ThirdpartyDocumentsAemItem } from '@app/models/aem.model';
import { LANDING_PAGE_CONTAINER } from '@app/constants/aem.constant';

@Component({
  selector: 'app-optimize-your-account',
  templateUrl: './optimize-your-account.component.html',
  styleUrls: ['./optimize-your-account.component.scss'],
  standalone: false,
})
export class OptimizeYourAccountComponent implements OnInit {
  density: any = 'small';
  hasImage = true;
  hasIcon = false;
  imagePadding = true;
  imageAspectRatio: CardImageAspectRatio = '3-2';

  @Input() thirdpartyDocumentsCaasContent: ThirdpartyDocumentsAemItem;
  optimizeTilesContent;


  ngOnInit() {
    this.getoptimizeTilesContent();
  }

  getoptimizeTilesContent() {
    const children = AemUtil.getChildren(LANDING_PAGE_CONTAINER, this.thirdpartyDocumentsCaasContent.children);
    this.optimizeTilesContent = AemUtil.getOptimizeTiles(children?.children ?? [], this.thirdpartyDocumentsCaasContent.additionalCta);
  }
}
